/*
auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/knight_hand.glb')
  return (
    <group ref={group} {...props}>
      <mesh geometry={nodes.knight_hand.geometry} >
        <meshStandardMaterial color={'white'}  roughness={'0.8'}/>
      </mesh>
    </group>
  )
}

useGLTF.preload('/knight_hand.glb')
